module.exports = __webpack_public_path__ + "files/3b77a736af995f8a3969fcb5babae5ea.png";